import { saveDiscipline as registerDiscipline } from './api'
import { saveSubdiscipline as registerSubdiscipline } from './api'
import { deleteDiscipline as destroyDiscipline } from './api'
import { deleteSubdiscipline as destroySubdiscipline } from './api'

const saveDiscipline = async ({ commit }, payload) => {
  try {
    return await registerDiscipline(payload)
  }
  catch (e) {
    console.error(e)
  }
}

const saveSubdiscipline = async ({ commit }, payload) => {
  try {
    return await registerSubdiscipline(payload)
  }
  catch (e) {
    console.error(e)
  }
}

const deleteDiscipline = async ({ commit }, payload) => {
  try {
    return await destroyDiscipline(payload)
  }
  catch (e) {
    console.error(e)
  }
}

const deleteSubdiscipline = async ({ commit }, payload) => {
  try {
    return await destroySubdiscipline(payload)
  }
  catch (e) {
    console.error(e)
  }
}

export default {
  saveDiscipline,
  saveSubdiscipline,
  deleteDiscipline,
  deleteSubdiscipline,
}
